import React, {useEffect, useState} from 'react';
import Layout from "../components/layout/layout";
import Masonry from "../components/masonry/masonry";
import CallToAction from "../components/callToAction/callToAction";
import CategoryContainer from "../components/categoryContainer/categoryContainer";
import {graphql, useStaticQuery} from "gatsby";
import "../sass/pages/illustration.scss";
import {getImage} from "gatsby-plugin-image";
import COSParser from "../modules/cosParser";
import rowMaker from "../components/masonry/rowMaker";
import rowSizer from "../components/masonry/rowSizer";

function Illustration () {
    let query = useStaticQuery(graphql`
 query illustration {
    allContentfulIllustrationPage {
        nodes {
            imageOrder
            big {
                file {
                    details{
                        image{
                            width
                            height
                        }
                    }
                }
                gatsbyImageData(
                    placeholder: DOMINANT_COLOR
                    formats: [AUTO, WEBP]
                )
            }
            small {
                file {
                    details{
                        image{
                            width
                            height
                        }
                    }
                }
                gatsbyImageData(
                    placeholder: DOMINANT_COLOR
                    formats: [AUTO, WEBP]
                )
            }
            horizontal {
                file {
                    details{
                        image{
                            width
                            height
                        }
                    }
                }
                gatsbyImageData(
                    placeholder: DOMINANT_COLOR
                    formats: [AUTO, WEBP]
                )
            }
            wide {
                file {
                    details{
                        image{
                            width
                            height
                        }
                    }
                }
                gatsbyImageData(
                    placeholder: DOMINANT_COLOR
                    formats: [AUTO, WEBP]
                )
            }
        }
    }
}`);
    const [imageURL,setURL]=useState("");
    const [counter,setCounter] = useState(0);
    const [viewportWidth,setViewportWidth] = useState(null);
    const { big, small, horizontal, wide, imageOrder } = query["allContentfulIllustrationPage"].nodes[0];

    let max = imageOrder.split(" ").length - 1;

    useEffect(() => {
        if(typeof window !== "undefined"){
            let w = document.querySelector(".masonry").getBoundingClientRect().width;
            setViewportWidth(w * .975 + w * .01);
        }
    },[])

    const photos = {
        big,
        small,
        horizontal,
        wide,
    };

    Object.keys(photos).forEach(key => {
        photos[key] = photos[key].map(getImage)
    })

    let parser = new COSParser({
        B: "big",
        S: "small",
        H: "horizontal",
        W: "wide",
    });
    let order = parser.parseOrder(imageOrder);
    let rows = rowMaker(order);
    const sizes = rowSizer(rows,query["allContentfulIllustrationPage"].nodes[0],viewportWidth);
    let carousel = rows.flat().map(({category,index})=>photos[category][index].images.fallback.src);

    const handleCounter = (value,overwrite) => ()=> {
        if(overwrite){
            setCounter(overwrite)
        }else{
            let newCount = counter+value;
            if (newCount > max) {
                newCount = 0;
            } else if (newCount < 0) {
                newCount = max;
            }
            setCounter(newCount);
            setURL(carousel[newCount]);
        }
    };

        return (
            <Layout
                name={"illustration"}
                setCounter={handleCounter}
                counter={counter}
                hasModal
                max={max}
                current={"illustration"}
                modalContent={<img alt={'Illustration by Lauren Staser'} src={imageURL}/>}
                keywords={"Staser, creative, Illustration, children's, book, lettering, character, design"}
            >
                <section>
                    <CategoryContainer categories={["Children's book", "Lettering", "Character Design"]}>
                        illustration
                    </CategoryContainer>
                    <Masonry
                        viewportWidth={viewportWidth}
                        handleCounter={handleCounter}
                        carousel={carousel}
                        rows={rows}
                        sizes={sizes}
                        photos={photos}
                        index={counter}
                        imageClick={setURL}
                        query={query["allContentfulIllustrationPage"].nodes[0]}
                    />
            </section>
            <CallToAction/>
        </Layout>
        );
}

export default Illustration;
